import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.css";
import logo from "../../assests/Logo/bg.png";

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Toggle menu open state
  const toggleMenu = () => setMenuOpen(!menuOpen);

  // Close menu when a link is clicked (optional)
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="navbar-wrapper">
      <nav className="navbar">
        <div className="navbar-logo">
          <img src={logo} alt="Logo" className="logo-image" width={100} />
          <span className="logo-text">Innovation Solutions</span>
        </div>

        <div className="hamburger" onClick={toggleMenu} aria-label="Toggle Menu" aria-expanded={menuOpen}>
  {menuOpen ? (
    <span className="close-icon">×</span>  
  ) : (
    <div className="bars">
      <span className="bar"></span>
      <span className="bar"></span>
      <span className="bar"></span>
    </div>
  )}
</div>


        {/* Navigation Links */}
        <ul className={`navbar-links ${menuOpen ? "active" : ""}`}>
          <li>
            <Link to="/" onClick={closeMenu} className={location.pathname === "/" ? "active" : ""}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about-us" onClick={closeMenu} className={location.pathname === "/about-us" ? "active" : ""}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/our-services" onClick={closeMenu} className={location.pathname === "/our-services" ? "active" : ""}>
              Our Services
            </Link>
          </li>
          <li>
            <Link to="/gallery" onClick={closeMenu} className={location.pathname === "/gallery" ? "active" : ""}>
              Gallery
            </Link>
          </li>

            <li>
            <Link to="/accreditations" onClick={closeMenu} className={location.pathname === "/accreditations" ? "active" : ""}>
              Accreditations
            </Link>
          </li>
          <li>
            <Link to="/contact-us" onClick={closeMenu} className={location.pathname === "/contact-us" ? "active" : ""}>
              Contact Us
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
